import {AttributeDescriptor, BaseModel, BaseModelDescriptor} from "./BaseModel";
import {ValidationTypes} from "../core/Validator";

export class Position extends BaseModel {

	id: string
    title: string
    description: string
	departmentId: string
}

export class PositionDescriptor extends BaseModelDescriptor{
	static id: AttributeDescriptor = {validation: []}
	static title: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static description: AttributeDescriptor = {validation: []}
	static departmentId: AttributeDescriptor = {validation: []}
}
